// src/components/Sidebar.jsx — v9.7
//   - focusedNavigation=true: only Analyze, Incident Reports, Dashboard shown
//   - "Continuous Monitoring" removed from primaryNav (not our positioning)
//   - Advanced section hidden from nav (routes and pages remain fully intact)
//   - No structural changes, no new dependencies

import { NavLink } from "react-router-dom";

// v1 launch navigation: focus users on core forensic workflow
// to reduce onboarding friction and cognitive overload.
// Set to false to restore full nav for internal/developer access.
// Routes and pages are NOT removed — accessible via direct URL regardless of this flag.
const focusedNavigation = true;

const primaryNav = [
  { label: "Analyze",          to: "/analyze",    accent: true },
  { label: "Upload Screenshot", to: "/screenshot" },
  { label: "Incident Reports", to: "/reports"   },
];

const advancedNav = [
  { label: "Finance",   to: "/finance"   },
  { label: "Alerts",    to: "/alerts"    },
  { label: "Campaigns", to: "/arbitrage" },
  { label: "Engine",    to: "/engine"    },
  { label: "Test Lab",  to: "/test"      },
  { label: "Logs",      to: "/logs"      },
];

// Core workflow sections shown in focusedNavigation mode
const CORE_ROUTES = new Set(["/analyze", "/reports", "/dashboard"]);

function NavItem({ item, muted }) {
  return (
    <NavLink to={item.to} style={{ textDecoration: "none" }}>
      {({ isActive }) => (
        <div style={{
          padding:      "8px 14px",
          borderRadius: "var(--radius-sm)",
          cursor:       "pointer",
          transition:   "all var(--t-fast)",
          background:   isActive ? "var(--accent-faint)" : "transparent",
          color:        isActive     ? "var(--accent-primary)"
                      : muted       ? "var(--text-tertiary)"
                      : item.accent ? "var(--text-primary)"
                      : "var(--text-secondary)",
          borderLeft:   isActive ? "2px solid var(--accent-primary)" : "2px solid transparent",
          fontSize:     muted ? 12 : 13,
          fontWeight:   isActive ? 500 : 400,
          letterSpacing: "0.01em",
          fontFamily:   "var(--font-mono)",
        }}>
          {item.label}
        </div>
      )}
    </NavLink>
  );
}

export default function Sidebar() {
  return (
    <aside style={{
      width:        220,
      flexShrink:   0,
      background:   "var(--bg-secondary)",
      borderRight:  "1px solid var(--border-subtle)",
      display:      "flex",
      flexDirection:"column",
      padding:      "16px 8px",
      gap:          2,
      overflowY:    "auto",
    }}>

      {/* Logo */}
      <div style={{
        fontFamily:    "var(--font-mono)",
        fontSize:      13,
        fontWeight:    700,
        color:         "var(--text-primary)",
        letterSpacing: "0.06em",
        padding:       "6px 14px 14px",
        borderBottom:  "1px solid var(--border-subtle)",
        marginBottom:  8,
      }}>
        VIRAJ
      </div>

      {/* Primary nav */}
      {primaryNav.map(item => (
        <NavItem key={item.to} item={item} muted={false} />
      ))}

      {/* Advanced nav — hidden in focusedNavigation mode */}
      {!focusedNavigation && (
        <>
          <div style={{
            fontFamily:    "var(--font-mono)",
            fontSize:      9,
            color:         "var(--text-tertiary)",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            padding:       "12px 14px 4px",
          }}>
            Advanced
          </div>
          {advancedNav.map(item => (
            <NavItem key={item.to} item={item} muted={true} />
          ))}
        </>
      )}

    </aside>
  );
}
